export const CANDIDATES_FETCH = 'candidates/fetchSearch';
export const CANDIDATES_FETCH_PENDING = `${CANDIDATES_FETCH}/pending`;
export const CANDIDATES_FETCH_FULFILLED = `${CANDIDATES_FETCH}/fulfilled`;
export const CANDIDATES_FETCH_REJECTED = `${CANDIDATES_FETCH}/rejected`;

export const CANDIDATE_LOAD_START = 'CANDIDATE_LOAD_START';
export const CANDIDATE_LOAD_SUCCESS = 'CANDIDATE_LOAD_SUCCESS';
export const CANDIDATE_LOAD_FAILURE = 'CANDIDATE_LOAD_FAILURE';

export const CANDIDATE_SEARCH_CHANGE_FILTER = 'CANDIDATE_SEARCH_CHANGE_FILTER';
export const CANDIDATE_MESSAGED = 'CANDIDATE_MESSAGED';
export const CANDIDATE_SEARCH_RESET_FILTER = 'CANDIDATE_SEARCH_RESET_FILTER';

export const RECOMMENDATIONS_PARAMETERS_UPDATED = 'RECOMMENDATIONS_PARAMETERS_UPDATED';

export const METADA_FULFILLED = 'METADA_FULFILLED';

export const UPDATE_DROPDOWN_FILTER = 'UPDATE_DROPDOWN_FILTER';

export const UPDATE_SHOW_RECOMMENDATIONS = 'UPDATE_SHOW_RECOMMENDATIONS';
export const APPLY_SAVED_FILTER_ID = 'APPLY_SAVED_FILTER_ID';
export const CANDIDATE_APPLY_SAVED_FILTER = 'CANDIDATE_APPLY_SAVED_FILTER';
export const MARK_FILTERS_AS_SEARCHED = 'MARK_FILTERS_AS_SEARCHED';
